import { isEmpty } from 'util/validation/Util'

import { CidadaoAtendimento } from '../types/CidadaoAtendimento'

export const getSexoCidadao = (cidadao: CidadaoAtendimento) =>
  isEmpty(cidadao?.identidadeGeneroDbEnum) ? cidadao?.sexo : undefined
